import { getLocale, getEmbedded } from '@/helpers/Utils';
import {
	CHANGE_LOCALE,
	CHANGE_LOADING,
	CHANGE_EMBEDDED,
	CHANGE_DIRTY,
} from '../actions-registry';

const INIT_STATE = {
	embedded: getEmbedded(),
	locale: getLocale(),
	loading: false,
	dirty: false,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case CHANGE_LOCALE:
			return { ...state, locale: action.payload };
		case CHANGE_LOADING:
			return { ...state, loading: action.payload };
		case CHANGE_EMBEDDED:
			return { ...state, embedded: action.payload };
		case CHANGE_DIRTY:
			return { ...state, dirty: action.payload };
		default:
			return { ...state };
	}
};
